// ABOUTME: The padding of the content of every custom page: the list view and the center column of a full-bleed page.
// ABOUTME: Side panels keep their own padding (see LayoutRenderer); this one is not configurable.

export const PAGE_CONTENT_PADDING = { px: 4, py: 3 } as const;
